import { Component, Input, EventEmitter, Output } from '@angular/core';
import { SearchResult } from '../../core-data-model/SearchResult.model';
import { SearchResultSet } from '../../core-data-model/SearchResultSet';
import { Table } from '../../core-services/Tables/Table';
import { Util } from '../../core-utilities/Util';
import { TranslationService } from '../../translations';

@Component({
    selector: 'pi-table-global-select',
    template: `
        @if (showSelectAll) {
            <span (click)="addAll()" class="lsg-link">
                {{ selectAllString }}
            </span>
        }
        @if (showDeselectAll) {
            <span (click)="removeAll()" class="lsg-link">
                {{ deselectAllString }}
            </span>
        }
    `,
    standalone: false
})
export class NewTableGlobalSelectComponent {
    // <T>
    @Input()
    table: Table<SearchResult>; // Hopefully this should become T
    @Input()
    selection: SearchResultSet;

    @Output()
    selectionChanged = new EventEmitter<SearchResultSet>();

    constructor(
        public TR: TranslationService,
        private util: Util
    ) {}

    get showSelectAll() {
        return (
            this.selection &&
            this.selection.allResultsInContext &&
            typeof this.selection.allResultsInContext === 'function' &&
            this.selection.allResultsInContext(this.table.contents) &&
            this.table?.searchState &&
            this.table?.searchState?.pageState?.maxResults >
                this.table?.searchState?.pageState?.resultsPerPage
        );
    }

    get showDeselectAll() {
        return (
            this.selection &&
            this.selection.noResultsInContext &&
            typeof this.selection.noResultsInContext === 'function' &&
            this.selection.noResultsInContext(this.table.contents) &&
            this.selection.size > 0
        );
    }

    async addAll() {
        if (this.table && this.selection) {
            const newSelection = await this.table.copyAllToContext(
                this.selection
            );
            this.selectionChanged.emit(newSelection);
        }
    }

    removeAll() {
        this.selectionChanged.emit(this.selection.clear());
    }

    get selectAllString(): string {
        return this.util.strings.formatString(
            this.TR.key('piTable.selectAll'),
            this.table.searchState.pageState.maxResults
        );
    }

    get deselectAllString(): string {
        return this.util.strings.formatString(
            this.TR.key('piTable.deselectAll'),
            this.selection.size
        );
    }
}

// How dow this potentially change behavior
